import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { MfaRecoveryCodesDisplay } from '@/features/auth/components/MFASetup/MfaRecoveryCodesDisplay';
import PageMeta from '@/shared/components/PageMeta';

export const MFARecoveryCodes: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const codes: string[] = location.state?.codes ?? [];

    useEffect(() => {
        if (!codes.length) {
            navigate('/', { replace: true });
        }
    }, [codes.length, navigate]);

    if (!codes.length) {
        return null;
    }

    return (
        <>
            <PageMeta
                title="Recovery Codes"
                description="Save your MFA recovery codes"
            />
            <MfaRecoveryCodesDisplay codes={codes} onConfirm={() => navigate('/', { replace: true })} />
        </>
    );
};
